/**
 * Created by Owner on 2016/7/26.
 */
import {Injectable} from '@angular/core';
import {AppConfigService} from '../services/appConfig.service';

@Injectable()
export class UserService {

    constructor(private configService: AppConfigService) {

    }

    /**
     * 检测版本
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    checkVersion(data = {}, nav: any) {
        data["flag"] = 'getVersion1';
        return this.configService.getMobileService(data, nav);
    }

    getServerList(data = {}, nav: any) {
        data["flag"] = 'getServerList';
        return this.configService.getMobileService(data, nav);
    }

    /**
     * 登陆提交
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    login(data, nav: any) {
        data["flag"] = 'LoginBean_loginnew';
        return this.configService.getUserService(data, nav);
    }

    /**
     * Update user info
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    updateUserInfo(data, nav: any) {
        data["flag"] = 'LoginBean_updateUserInfo';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 主页面初始化
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    initHome(data = {}, nav: any) {
        data["flag"] = 'initmain';
        return this.configService.getMobileService(data, nav);
    }

    /**
     * 代理注册初始化
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    agentRegisterInit(data, nav: any) {
        data["flag"] = 'AgentRegBean';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 代理注册保存
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    agentRegisterSave(data, nav: any) {
        data["flag"] = 'AgentRegBean_save';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 下级会员查询
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    agentUserSearch(data, nav: any) {
        data["flag"] = 'AgentUserSearchBean_btnSearch';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 下级会员查询下一页
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    agentUserSearchNext(data, nav: any) {
        data["flag"] = 'AgentUserSearchBean_nextPage';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 下级会员查询编辑
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    agentUserEdit(data, nav: any) {
        data["flag"] = 'AgentUserSearchBean_edits';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 给下级会员分配金额
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    agentUserDeposit(data, nav: any) {
        data["flag"] = 'AgentUserSearchBean_deposit';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 下级会员返点信息初始化
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    agentUserPointInit(data, nav: any) {
        data["flag"] = 'AgentUserSearchBean_pointEdit';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 下级会员返点信息更新
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    agentUserPointUpdate(data, nav: any) {
        data["flag"] = 'AgentUserSearchBean_update';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 下级会员返点信息更新
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    agentUserTBalance(data, nav: any) {
        data["flag"] = 'AgentUserSearchBean_tbalance';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 用户返点编辑
     * @param data
     * @param nav
     * @returns {Promise<T>}
     * @constructor
     */
    agentUserPointEdit(data, nav: any) {
        data["flag"] = 'AgentUserSearchBean_pointEdit';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 给下级会员配额编辑
     * @param dataS
     * @param nav
     * @returns {Promise<T>}
     */
    agentUserSavePe(data, nav: any) {
        data["flag"] = 'AgentUserSearchBean_savePe';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 下级会员投注查询初始化
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    agentUserBetInit(data, nav: any) {
        data["flag"] = 'AgentBetBean_init';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 下级会员投注查询
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    agentUserBetSearchNext(data, nav: any) {
        data["flag"] = 'AgentBetBean_nextPage';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 下级会员投注查询
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    agentUserBetSearch(data, nav: any) {
        data["flag"] = 'AgentBetBean_btnSearch';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 下级会员账变
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    agentUserZbInit(data, nav: any) {
        data["flag"] = 'AgentZbBean_init';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 下级会员账变查询
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    agentUserZbSearch(data, nav: any) {
        data["flag"] = 'AgentZbBean_btnSearch';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 账变下一页
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    agentUserZbSearchNext(data, nav: any) {
        data["flag"] = 'AgentZbBean_nextPage';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 推广列表
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    agentUserAutoRegList(data = {}, nav: any) {
        data["flag"] = 'AgentAutoRegBean';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 新建推广链接
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    agentAutoRegNew(data = {}, nav: any) {
        data["flag"] = 'AgentAutoRegBean_save';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 编辑推广链接
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    agentAutoRegEdit(data = {}, nav: any) {
        data["flag"] = 'AgentAutoRegBean_update';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 获取团队余额
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    agentBalance(data = {}, nav: any) {
        data["flag"] = 'AgentBalanceBean';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 统计报表初始化
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    reportWinLossInit(data = {}, nav: any) {
        data["flag"] = 'ReportWinLossBean';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 统计报表查询
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    reportWinLossSearch(data = {}, nav: any) {
        data["flag"] = 'ReportWinLossBean_bntSearch';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 团队总览初始化
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    reportTDInit(data = {}, nav: any) {
        data["flag"] = 'ReportTDBean';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 团体总览查询
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    reportTDSearch(data = {}, nav: any) {
        data["flag"] = 'ReportTDBean_mainSearch';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 初始化配额
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    agentPEBeanInit(data = {}, nav: any) {
        data["flag"] = 'AgentPEBean';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 查询下级配额
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    agentPEBeanSearch(data = {}, nav: any) {
        data["flag"] = 'AgentPEBean_bntsearch';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 查询下级配额下一页
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    agentPEBeanSearchNext(data = {}, nav: any) {
        data["flag"] = 'AgentPEBean_proPage';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 代理陪额下级初始化
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    agentPESub(data = {}, nav: any) {
        data["flag"] = 'AgentPESubBean';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 每日下级统计报表查询初始化
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    reportWinLoss2Init(data = {}, nav: any) {
        data["flag"] = 'ReportWinLoss2Bean';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 每日下级统计报表查询
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    reportWinLoss2List(data = {}, nav: any) {
        data["flag"] = 'ReportWinLoss2Bean_btnSearch';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 每日下级统计报表查询
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    reportWinLoss2ListNext(data = {}, nav: any) {
        data["flag"] = 'ReportWinLoss2Bean_nextPage';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 充值初始化
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    deposit(data = {}, nav: any) {
        data["flag"] = 'DepositBean';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 充值查询初始化
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    depositSearchInit(data = {}, nav: any) {
        data["flag"] = 'DepositSearchBean';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 充值查询初始化
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    depositSearch(data = {}, nav: any) {
        data["flag"] = 'DepositSearchBean_btnSearch';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 充值查询
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    depositSearchNext(data = {}, nav: any) {
        data["flag"] = 'DepositSearchBean_nextPage';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 提现初始化
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    withdrawal(data = {}, nav: any) {
        data["flag"] = 'WithdrawalBean';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 提现接口
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    withdrawalApply(data = {}, nav: any) {
        data["flag"] = 'WithdrawalBean_apply';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 银行卡管理
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    personBankCard(data = {}, nav: any) {
        data["flag"] = 'PersonBankCardBean';
        return this.configService.getUserService(data, nav);
    }

    lockBankcard(data = {}, nav: any) {
        data["flag"] = 'PersonBankCardBean_lockBankcard';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 银行卡管理添加
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    addBankcardCheck(data = {}, nav: any) {
        data["flag"] = 'PersonBankCardBean_addBankcardCheck';
        return this.configService.getUserService(data, nav);
    }
    /**
      xoa tai khoan
    */
    deleteBankcard(data = {}, nav: any) {
        data["flag"] = 'PersonBankCardBean_deleteBankcard';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 添加银行卡确定
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    addBankcardCheckAdd(data = {}, nav: any) {
        data["flag"] = 'PersonBankCardBean_addBankcard';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 修改登录密码
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    editLoginPassWord(data = {}, nav: any) {
        data["flag"] = 'PersonPwdBean_loginPWD';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 修改登录密码
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    editMoneyPassWord(data = {}, nav: any) {
        data["flag"] = 'PersonPwdBean_checkPWD';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 修改昵称
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    editNickName(data = {}, nav: any) {
        data["flag"] = 'LoginBean_changeNickName';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 修改昵称
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    editPhone(data = {}, nav: any) {
        data["flag"] = 'LoginBean_changePhone';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 提现记录初始化
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    WithdrawalSearchInit(data = {}, nav: any) {
        data["flag"] = 'WithdrawalSearchBean';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 提现记录首页
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    WithdrawalSearch(data = {}, nav: any) {
        data["flag"] = 'WithdrawalSearchBean_btnSearch';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 提现记录下一页
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    WithdrawalSearchNext(data = {}, nav: any) {
        data["flag"] = 'WithdrawalSearchBean_nextPage';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 查询发送信息
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    personMsgSendSearch(data = {}, nav: any) {
        data["flag"] = 'PersonMsgSendBean_btnSearch';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 查询发送信息
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    personMsgSendSearchNext(data = {}, nav: any) {
        data["flag"] = 'PersonMsgSendBean_nextPage';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 查询发送给我的信息信息
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    personMessageSearch(data = {}, nav: any) {
        data["flag"] = 'PersonMessageBean_btnSearch';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 查询发送给我的信息信息
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    personMessageSearchNext(data = {}, nav: any) {
        data["flag"] = 'PersonMessageBean_nextPage';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 查询发送给我的信息信息
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    personMessageSave(data = {}, nav: any) {
        data["flag"] = 'PersonMsgSendBean_save';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 删除详细
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    personMessageDel(data = {}, nav: any) {
        data["flag"] = 'PersonMessageBean_del';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 查看详情
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    personMessageView(data = {}, nav: any) {
        data["flag"] = 'PersonMessageBean_view';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 游戏记录初始化
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    gameRecordInit(data = {}, nav: any) {
        data["flag"] = 'GameRecordBean';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 游戏记录查询
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    gameRecordSearch(data = {}, nav: any) {
        data["flag"] = 'GameRecordBean_mobileSearch';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 游戏记录下一页
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    gameRecordSearchNext(data = {}, nav: any) {
        data["flag"] = 'GameRecordBean_nextPage';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 查看追号记录详情
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    traceSearch(data = {}, nav: any) {
        data["flag"] = 'TraceSearchBean_btnSearch';
        return this.configService.getUserService(data, nav);
    }

    traceRecord(data = {}, nav: any) {
        data["flag"] = 'TraceRecordBean';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 查看追号记录详情
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    traceSearchNext(data = {}, nav: any) {
        data["flag"] = 'TraceSearchBean_nextPage';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 帐变查询初始化
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    balanceChangeInit(data = {}, nav: any) {
        data["flag"] = 'BalanceChangeBean';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 帐变查询
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    balanceChangeSearch(data = {}, nav: any) {
        data["flag"] = 'BalanceChangeBean_btnSearch';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 帐变查询下一页
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    balanceChangeSearchNext(data = {}, nav: any) {
        data["flag"] = 'BalanceChangeBean_nextPage';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 查看全部系统公告
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    sysMsgBean(data = {}, nav: any) {
        data["flag"] = 'SysMsgBean';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 查看某条系统公告详情
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    sysMsgBeanInfo(data = {}, nav: any) {
        data["flag"] = 'SysMsgBean_showmsg';
        return this.configService.getUserService(data, nav);
    }

    /**
     * 查看某条系统公告详情
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    loginOut(data = {}, nav: any) {
        data["flag"] = 'LoginBean_loginout';
        return this.configService.getUserService(data, nav);
    }
    /**
     * 查看某条系统公告详情
     * @param data
     * @param nav
     * @returns {Promise<T>}
     */
    confirmNumPhone(data = {}, nav: any) {
        data["flag"] = 'PersonPwdBean_confirmNumPhone';
        return this.configService.getUserService(data, nav);
    }

    accountTryTest(data = {}, nav: any) {
        data['flag'] = 'RegBean_UITestUserAdd';
        return this.configService.getUserService(data, nav);
    }

    auditUser(data = {}, nav: any) {
        data['flag'] = 'AuditUserBean_auditUser';
        return this.configService.auditUser(data, nav);
    }
}



// WEBPACK FOOTER //
// ./src/services/user.services.ts